import {useRef, useState} from 'react';
import {SActionBtn, SLowcodeList, SMessage, STableActions} from 'shj-components';
import config from './config';
import {Select, message} from 'antd';
import {addOrEditFn} from './addOrEdit';
import KeepAlive from 'react-activation';
import {getNewInsurAccountsFindConfPageByRequest, newInsurAccountsDeleteById} from "@/services/insureManagement.ts";
import {moneyRender} from "@/utils";
import {get} from "lodash-es";
import dayjs from "dayjs";

export default function (props: any) {
  const {Option} = Select;
  const listRef = useRef<any>();
  const [companyList, setCompanyList] = useState([]);
  // 表格数据
  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise((resolve, reject) => {
      try {
        const {current, pageSize, query} = values;
        query.inpriod = 0
        getNewInsurAccountsFindConfPageByRequest(current, pageSize, query).then((resp: any) => {
          resolve({records: resp?.records || [], total: resp?.total || 0})
        })
      } catch (e) {
        reject({success: false})
      }
    })
  }
  // 获取select查询数据
  const getStatusOptions = () => {
    return new Promise(async (resolve) => {
      let companyList = props?.companyList;
      let enabledList = [
        {
          code: 1,
          name: '启用',
        },
        {
          code: 0,
          name: '禁用',
        },
      ];
      setCompanyList(companyList);
      resolve({
        companyList: companyList,
        enabledList,
      });
    });
  };
  // 修改状态
  const editConfiguration = async(obj) => {
    addOrEditFn({
      fn: () => {
        listRef.current.reload();
      },
      ...obj,
    });
  };
  const delConfiguration = async (id) => {
    const dialog = SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await newInsurAccountsDeleteById(id)
          if (res.errorCode === 0) {
            message.success('删除成功');
            listRef.current.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
        dialog?.destroy();
      },
      onCancel: () => {
        message.warning('取消删除');
        dialog?.destroy();
      },
    });
  };
  // 新增or编辑
  const onAddOrEdit = async (record: any) => {
    addOrEditFn({
      fn: () => {
        listRef.current.reload();
      },
      ...record,
      companyList,
    });
  };
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAddOrEdit },
    customRender: {
      money(text: any) {
        return <span>{moneyRender(text)}</span>
      },
      startDateFn(text: any, record: any) {
        const startDate = dayjs(record.startDate).format('YYYY-MM-DD')
        const endDate = dayjs(record.endDate).format('YYYY-MM-DD')
        return `${startDate}——${endDate}`;
      },
      enabledFn(text: any, record: any) {
        return <span>{record.enabled ? '启用' : '禁用'}</span>;
      },
      setCompany({ key, name, form }: any) {
        return (
            <Select
                mode="multiple"
                showSearch
                allowClear={true}
                filterOption={(input: any, option: any) => {
                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
                onChange={(value) => {
                  form.setFieldsValue({
                    [name]: value,
                })
              }}
            >
                {(props.allCompanyList || []).map((item: any, i: any) => {
                    return (
                        <Option key={i} value={item.orgId}>
                            {item.companyName}
                        </Option>
                    );
                })}
            </Select>
        );
    },
      operationFn(text: any, record: any) {
        return (
          <STableActions>
            {record.canAddBalance === 0
                ? null
                : <SActionBtn 
                auth="insurancesettingOnEdit" 
                onClick={() => editConfiguration({
                  id: record.id,
                  enabled: !record.enabled,
                })}>
                  编辑
                </SActionBtn>}
            <SActionBtn
                auth="insurancesettingDelete"
                disabled={record?.enabled === 1}
                danger onClick={() => delConfiguration(`${record?.id}`)}
                >
              删除
            </SActionBtn>
          </STableActions>
        );
      },
    },
  };

  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <SLowcodeList searchMode="group" config={config} ref={listRef} {...extension} />
    </KeepAlive>
  );
}
